import React from 'react';

import moment from 'moment';
import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';

import Alert from '../../../Alert';

import LoanService from '../../../../services/LoanService';
import formatCurrency from '../../../../helpers/formatCurrency';

export default function DemandAlert({ loanId, className }) {
  const { data: demands } = useQuery({
    queryKey: ['demands', loanId],
    queryFn: () => LoanService.getLoanDemands(loanId),
    enabled: !!loanId,
  });

  const activeDemands = demands?.filter((demand) => demand.status === 'active');
  const hasActiveDemands = activeDemands?.length > 0;

  if (!hasActiveDemands) {
    return null;
  }

  return (
    <ul className={classNames('mb-5 flex flex-col gap-2', className)}>
      {activeDemands.map((demand) => (
        <li key={demand.id}>
          <Alert
            message={`There is an active demand letter for this loan sent ${moment(
              demand.created_at
            ).format('M/D/YY')} in the amount of $${formatCurrency(
              demand.amount
            )}.`}
          />
        </li>
      ))}
    </ul>
  );
}
